import React, { useEffect } from 'react';

const AdSense = () => {
  useEffect(() => {
    window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.push({});
  }, []);

  return (
    <ins
      className={`adsbygoogle`}
      style={{display:'block'}}
      data-ad-client="ca-pub-7098804305049991"
      data-ad-slot="8394462901"
      data-ad-format="fluid"
    ></ins>
  );
};

export default AdSense;
